export default __webpack_public_path__ + "static/media/chuseok1.3542bf30.jpg";